import { Outlet, useLocation } from "react-router-dom";
import { SIDEBAR_GROUPS } from "../components/layout/sidebar-config";
import UnauthorizedPage from "../features/not-found/unauthorized-page";
import { usePermission } from "../hooks/usePermission";

export const PermissionRoutes = () => {
  const { hasPermission } = usePermission();
  const location = useLocation();
  const currentPath = location.pathname;

  const allItems = SIDEBAR_GROUPS.flatMap((g) => g.items);
  const item = allItems.find((i) => i.path && i.path === currentPath);

  if (item && item.permissionCodes && item.permissionCodes.length > 0) {
    const allowed = hasPermission(item.permissionCodes);
    if (!allowed) {
      return <UnauthorizedPage />;
    }
  }

  return <Outlet />;
};

export default PermissionRoutes;
